var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEstructura(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.333 175V116.667L66.6667 75L25 116.667V175H66.6667M108.333 175H66.6667M108.333 175H175V33.3333C175 31.1232 174.122 29.0036 172.559 27.4408C170.996 25.878 168.877 25 166.667 25H83.3333C81.1232 25 79.0036 25.878 77.4408 27.4408C75.878 29.0036 75 31.1232 75 33.3333V83.3333M66.6667 175V141.667M108.333 58.3333V58.4167M141.667 58.3333V58.4167M141.667 91.6667V91.75M141.667 125V125.083",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstructura);
export default __webpack_public_path__ + "static/media/Estructura.9b6f15f80f99a0cb63ee65efdeda73da.svg";
export { ForwardRef as ReactComponent };